module.exports = __webpack_public_path__ + "static/media/arrow_left.9c9a7c51.svg";